import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import CommonInput from "../../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeFile,
  handleChangeNameValue,
} from "../../../../helpers/handleFormChanges";
import CommonSelect from "../../../../components/forms/CommonSelect";
import CommonInputValor from "../../../../components/forms/CommonInputValor";
import CommonInputFile from "../../../../components/forms/CommonInputFile";
import PropTypes from "prop-types";
import useTipos from "../../../../hooks/common/useTipos";

function NovoProLaboreModal({
  modalHook,
  valuesHook,
  socios,
  salvaProlabore,
  anoInicial,
  anoFinal,
}) {
  const { novoProLaboreModal, setNovoProLaboreModal } = modalHook;
  const { values, setValues } = valuesHook;
  const tiposProlabore = useTipos("tipos_prolabore");

  return (
    <CommonModal
      title="Novo pró-labore"
      is_open_modal={novoProLaboreModal}
      set_is_open_modal={setNovoProLaboreModal}
      size="xl"
      buttons={
        <CommonButton
          key={`upload-prolabore`}
          color="success"
          onClick={() => {
            salvaProlabore();
          }}
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonSelect
            label="Nome do sócio"
            id="socio"
            value={values.socio}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={
              socios &&
              Object.keys(socios).map((socio) => ({
                text: socios[socio].nome_empresarial,
                id: socios[socio].uid,
              }))
            }
            placeholder="Selecione a sócio"
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputValor
            label="Valor líquido"
            id="valor"
            value={values.valor}
            onChange={(e) => {
              handleChangeNameValue("valor", e.target.value, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonSelect
            label="Tipo de retirada"
            id="tipoRetirada"
            value={values.tipoRetirada}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={tiposProlabore.map((prolabore) => ({
              text: prolabore.valor,
              id: prolabore.chave,
            }))}
            placeholder="Selecione o tipo"
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-4 mb-3">
          <CommonInput
            label="Mês de referência"
            id="mesReferencia"
            value={values.mesReferencia}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            required
            min={`${anoInicial}-01`}
            max={`${anoFinal}-12`}
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInput
            label="Pagamento"
            id="mesPagamento"
            value={values.mesPagamento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="arquivo"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            accept="application/pdf"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

NovoProLaboreModal.propTypes = {
  modalHook: PropTypes.shape({
    novoProLaboreModal: PropTypes.bool.isRequired,
    setNovoProLaboreModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  socios: PropTypes.array.isRequired,
  salvaProlabore: PropTypes.func.isRequired,
  anoInicial: PropTypes.number.isRequired,
  anoFinal: PropTypes.number.isRequired,
};

export default NovoProLaboreModal;
